module.exports = __webpack_public_path__ + "img/pill-grid-8x3-540w.32003cd0.jpg";